import React from "react";
import "./Portfolio.css";
import playStore from "../../img/playstore.png";
import appStore from "../../img/ appstore.png";

import { useCallback } from "react";
import { useData } from "../../DataContext";

const Portfolio = () => {
  const { userData } = useData();

  const oneCard = useCallback((data) => {
    return (
      <div key={data.app_name} className="p-cardView">
        {disCard(data)}
        <div className="p-imageView" >
          {/* <a target={'_blank'}  rel="noopener noreferrer" style={{ textDecoration: 'none',alignSelf:'center' }}> */}
          <img src={data?.app_image} className={`p-appImage `} alt=""  res/>
          {/* </a> */}
          <div className="rowView">
            {data?.ios_url && storeCard("Appstore", data?.ios_url,appStore)}
            {data?.android_url && storeCard("Playstore", data?.android_url,playStore)}
          </div>
        </div>
      </div>
    )

  }, [])

  const disCard = (data) => {
    const { app_name,  description, specification } = data
    return (
      <div>
        {data?.app_icon && <img className="p-appIcon" src={data?.app_icon} alt="" />}
        <span className="p-appName">{app_name}</span>
        <span className="p-appdescription">{description}</span>
        <span className="p-appName">Spec</span>
        <div className="smallCard">
          {specification.map((i) => {
            return (
              <div key={i}>
                <span>{i}</span>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  const storeCard = (name, url,img) => {
    return (
      <a target={'_blank'} href={url} rel="noopener noreferrer" className="storeCard" style={{ textDecoration: 'none' }}>
        <img src={img} alt=""/>
        <div>
          <span>Available on</span>
          <span>{name}</span>
        </div>
      </a>
    )

  }



  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <div className="i-experinece">
        <span>Recent Projects</span>
      </div>
      {/* <span>Portfolio</span> */}
      {userData?.portfolio.sort((a,b) => a.order-b.order).map((item, index) => { return oneCard(item) })}
      <button onClick={() => { window.open(userData?.moreinfo, '_blank'); }} className="button morebutton">
        More
      </button>
    </div>
  );
};

export default Portfolio;
